import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import { UseQuery } from '@zapier/payment/src/ts-types';
import { currentUserQuery as CurrentUser } from './types/currentUserQuery';

export const currentUserQuery = gql`
  query currentUserQuery {
    currentUserV2 {
      id
    }
  }
`;

type Props = {
  skip?: boolean;
  useQuery?: UseQuery;
};

export const useCurrentUser = ({
  skip = false,
  // @ts-ignore
  useQuery = defaultUseQuery,
}: Props) => {
  const { data, error, loading } = useQuery<CurrentUser>(currentUserQuery, {
    skip,
  });

  return {
    currentUser: data?.currentUserV2,
    error: error ? 'Error loading current user information.' : undefined,
    isLoading: loading,
  };
};

export const useCurrentUserMock = {
  request: {
    query: currentUserQuery,
  },
  result: {
    data: {
      currentUserV2: {
        __typename: 'UserV2',
        id: '1',
      },
    },
  },
};
